import React from "react";
import { Link } from "react-router-dom";

interface InnerBannerProps {
  pageName: string;
}

const InnerBanner: React.FC<InnerBannerProps> = ({ pageName }) => {
  return (
    <section
      style={{
        position: "relative",
        minHeight: "135px",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",

        /* FULL BLACK */
        background: "#000000",

        borderBottom: "1px solid rgba(0,246,255,0.18)",

        boxShadow:
          "0 10px 30px rgba(0,0,0,0.9)",
      }}
    >

      {/* =========================
          SUBTLE BLACK GRID
      ========================= */}

      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",

          opacity: 0.08,

          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",

          backgroundSize: "34px 34px",
        }}
      />

      {/* =========================
          CYAN GLOW
      ========================= */}

      <div
        style={{
          position: "absolute",

          width: "220px",
          height: "220px",

          left: "-140px",
          top: "-100px",

          borderRadius: "50%",

          background: "rgba(0,246,255,0.035)",

          filter: "blur(90px)",

          pointerEvents: "none",
        }}
      />

      {/* =========================
          PURPLE GLOW
      ========================= */}

      <div
        style={{
          position: "absolute",

          width: "220px",
          height: "220px",

          right: "-140px",
          top: "-100px",

          borderRadius: "50%",

          background: "rgba(139,92,255,0.035)",

          filter: "blur(90px)",

          pointerEvents: "none",
        }}
      />

      {/* =========================
          CONTENT
      ========================= */}

      <div
        className="container"
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <div
          className="row align-items-center"
          style={{
            minHeight: "135px",
          }}
        >

          {/* =========================
              TITLE
          ========================= */}

          <div className="col-md-6 text-center text-md-start">

            {/* GROWNIVERSE */}

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",

                marginBottom: "7px",

                padding: "4px 10px",

                border:
                  "1px solid rgba(0,246,255,0.20)",

                borderRadius: "4px",

                background: "#000000",

                color: "#00f6ff",

                fontSize: "8px",

                fontWeight: 700,

                letterSpacing: "2px",

                textTransform: "uppercase",

                boxShadow:
                  "0 0 10px rgba(0,246,255,0.05)",
              }}
            >
              GROWNIVERSE
            </div>

            {/* PAGE NAME */}

            <h1
              style={{
                margin: 0,

                color: "#ffffff",

                fontSize:
                  "clamp(24px, 3vw, 36px)",

                fontWeight: 800,

                letterSpacing: "-0.5px",

                lineHeight: 1.1,

                textShadow:
                  "0 0 18px rgba(255,255,255,0.08)",
              }}
            >
              {pageName}
            </h1>

            {/* CYAN LINE */}

            <div
              style={{
                width: "50px",

                height: "2px",

                marginTop: "9px",

                background:
                  "linear-gradient(90deg, #00f6ff, transparent)",

                boxShadow:
                  "0 0 8px rgba(0,246,255,0.7)",
              }}
            />
          </div>

          {/* =========================
              BREADCRUMB
          ========================= */}

          <div className="col-md-6 mt-3 mt-md-0">

            <div
              className="justify-content-md-end"
              style={{
                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                gap: "8px",

                flexWrap: "wrap",

                fontSize: "12px",

                fontWeight: 600,
              }}
            >

              {/* HOME */}

              <Link
                to="/"
                style={{
                  display: "inline-flex",

                  alignItems: "center",

                  gap: "5px",

                  color: "#8b95a5",

                  textDecoration: "none",

                  transition:
                    "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color =
                    "#00f6ff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color =
                    "#8b95a5";
                }}
              >
                <i
                  className="fas fa-home"
                  style={{
                    fontSize: "11px",
                  }}
                />

                Home
              </Link>

              {/* SEPARATOR */}

              <span
                style={{
                  color: "#00f6ff",

                  fontSize: "13px",

                  opacity: 0.65,
                }}
              >
                /
              </span>

              {/* CURRENT PAGE */}

              <span
                style={{
                  color: "#ffffff",

                  padding: "5px 9px",

                  border:
                    "1px solid rgba(255,255,255,0.08)",

                  borderRadius: "4px",

                  background: "#000000",
                }}
              >
                {pageName}
              </span>

            </div>
          </div>
        </div>
      </div>

      {/* =========================
          BOTTOM CYAN SCAN LINE
      ========================= */}

      <div
        style={{
          position: "absolute",

          bottom: 0,

          left: "15%",
          right: "15%",

          height: "1px",

          background:
            "linear-gradient(90deg, transparent, rgba(0,246,255,0.55), transparent)",

          boxShadow:
            "0 0 8px rgba(0,246,255,0.35)",

          pointerEvents: "none",
        }}
      />

      {/* =========================
          CORNER ACCENTS
      ========================= */}

      <div
        style={{
          position: "absolute",

          left: "20px",
          bottom: "12px",

          width: "25px",
          height: "1px",

          background: "#00f6ff",

          opacity: 0.45,
        }}
      />

      <div
        style={{
          position: "absolute",

          right: "20px",
          bottom: "12px",

          width: "25px",
          height: "1px",

          background: "#8b5cff",

          opacity: 0.45,
        }}
      />

    </section>
  );
};

export default InnerBanner;